import { Accordion } from 'react-bootstrap'
import { Zoom } from 'react-awesome-reveal'
import '../../styles/Utils/AccordionText.css'

function AccordionText({ indexKey, header, body }) {

    return (

        <Zoom delay={(indexKey) * 50} duration={500}>
            <Accordion.Item eventKey={indexKey}>
                <Accordion.Header>
                    {header}
                </Accordion.Header>
                <Accordion.Body>
                    {body}
                </Accordion.Body>
                <div className='accordionBorder'></div>
            </Accordion.Item>
        </Zoom>

    )

}

export default AccordionText